export enum RoleEnum {
  Admin = 'Admin',
  Subscriber = 'Subscriber',
  Staff = 'Staff',
  Client = 'Client',
}
